import { render, staticRenderFns } from "./JettonTabHistorySkeletonMobile.vue?vue&type=template&id=341a5234&scoped=true&functional=true"
import script from "./JettonTabHistorySkeletonMobile.vue?vue&type=script&lang=js"
export * from "./JettonTabHistorySkeletonMobile.vue?vue&type=script&lang=js"
import style0 from "./JettonTabHistorySkeletonMobile.vue?vue&type=style&index=0&id=341a5234&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "341a5234",
  null
  
)

export default component.exports